
export class DayTime
{
    public constructor(
        public hours: number,
        public minutes: number,
        public seconds: number,
    )
    {
        if (this.hours % 1 > 0) {
            this.minutes += (this.hours % 1) * 60;
            this.hours -= this.hours % 1;
        }
        if (this.minutes % 1 > 0) {
            this.seconds += (this.minutes % 1) * 60;
            this.minutes -= this.minutes % 1;
        }

        if (this.seconds > 60) {
            this.minutes += Math.floor(this.seconds / 60);
            this.seconds %= 60;
        }
        if (this.minutes > 60) {
            this.hours += Math.floor(this.minutes / 60);
            this.minutes %= 60;
        }
    }

    public static makeFromString(time: string): DayTime
    {
        const timeParts = time.split(":");

        const seconds = Number.parseFloat(timeParts[timeParts.length - 1] ?? "0");
        const minutes = Number.parseInt(timeParts[timeParts.length - 2] ?? "0");
        const hours = Number.parseInt(timeParts[timeParts.length - 3] ?? "0");

        return new this(hours, minutes, seconds);
    }

    public toString(): string
    {
        return `${this.hours}:${this.minutes}:${this.seconds}`;
    }

    public numericValue(): number
    {
        return this.hours * 60 * 60 + this.minutes * 60 + this.seconds;
    }

    public dateEquals(date: Date): boolean
    {
        return (
            date.getHours() === this.hours &&
            date.getMinutes() === this.minutes &&
            date.getSeconds() === this.seconds
        );
    }

    public dateAtDay(dayDate: Date): Date
    {
        const tmp = new Date(dayDate.getTime());
        tmp.setMilliseconds(0);
        tmp.setSeconds(this.seconds);
        tmp.setMinutes(this.minutes);
        tmp.setHours(this.hours);

        return tmp;
    }
}
